import type { FaireProductEntity } from "../../entity_types/product";

export const p_n2qdbe29ts: FaireProductEntity = {
  token: "p_n2qdbe29ts",
  type: "product",
  name: "Horny For Books Gym Crew Socks",
  brandToken: "b_1fc44661",
  brandName: "Gumball Poodle",
  imageUrl: "https://cdn.faire.com/fastly/1fae484300e62172deec3148116d10017909a1781af5287b3ea5e95d34a8109d.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/7dacb1ed06b067e675a0ef113e53c2f738559409ec0dd87668bfd169200e1c9f.jpeg",
    "https://cdn.faire.com/fastly/0146797772d262421be02b19762ee3a6718d0b0e93151556f90554f2b3883c98.jpeg",
    "https://cdn.faire.com/fastly/e905299ebf60a9a716c18bd0d111c686e98f2685ae50ec17f954482488815cd4.jpeg",
    "https://cdn.faire.com/fastly/8914f27026b88c027b0809f23a391a18b975ad1d646f0c0fc1c83f7e62d2b04a.jpeg",
    "https://cdn.faire.com/fastly/94ff9202f10332fd9e0757e0b538fd25788e2b88bb40b6db6bd1b6c94075072e.jpeg",
    "https://cdn.faire.com/fastly/1f9ac4654306f45b809b3afb8e6e820a05b7528a3f34b126f0bf2f8f23caf1e2.jpeg",
    "https://cdn.faire.com/fastly/36b188815a7f496b98741370445d7009c6e66ae41f6e01ad843c9d0e7d785c1d.jpeg"
  ],
  priceDollars: 6.75,
  description: "There's nothing better than getting your nose between a perfect set of pages 🤤 . If you like to lose yourself for hours reading books, then you're probably horny for books, so you should probably have some snappy socks that say you are...horny for books.\n\nGumball Poodle is GPSR compliant! We will automatically be stickering all orders into the EU or Northern Ireland for GPSR compliance. \n\nIf you are in the UK but sell into the EU, we can provide you with the necessary stickers to put on products - be sure to tell us you need these when you place your order.",
  tags: [],
  msrpDollars: 14,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-10-12T05:31:09.575Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
